import { render, staticRenderFns } from "./PoultryHouseSelection.vue?vue&type=template&id=35f6caba&scoped=true&"
import script from "./PoultryHouseSelection.vue?vue&type=script&lang=js&"
export * from "./PoultryHouseSelection.vue?vue&type=script&lang=js&"
import style0 from "./PoultryHouseSelection.vue?vue&type=style&index=0&id=35f6caba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f6caba",
  null
  
)

export default component.exports